module.exports = __webpack_public_path__ + "fondo.svg?6f08603d700adaddb45944bac6d39b78";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fondo.svg
// module id = 216
// module chunks = 0